import React, { useContext, useEffect, useMemo } from "react";
import styles from "./style.module.css";
import DocumentPage from "../../components/document-page";
import { DataContext, IDataContextValue } from "../../context/dataProvider";
import { SUBSCRIPTION_TYPE_NAME } from "../../context/types";
import { useAuth } from "../../context/authContext";

function HistoryPage() {
  const data: IDataContextValue | null = useContext(DataContext);
  const { status } = useAuth();

  useEffect(() => {
    if (status === "authed" && !data?.user && !data?.isLoading) {
      void data?.fetchData();
    }
  }, [status, data?.user, data?.isLoading, data?.fetchData]);

  const orders = useMemo(() => {
    const list = data?.user?.orders ?? [];
    return [...list].sort(
      (a, b) => new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
    );
  }, [data?.user?.orders]);

  if (data?.isLoading || (status === "authed" && !data?.user)) {
    return null;
  }

  if (!data?.user) {
    return null;
  }

  return (
    <DocumentPage variant="scrollable">
      <h1>История покупок</h1>
      <div className={styles.orders}>
        {orders.length === 0 ? (
          <p className={styles.empty}>Оплаченных покупок пока нет</p>
        ) : (
          orders.map((order) => (
            <div className={styles.order} key={order.id}>
              <div>{new Date(order.createdAt).toLocaleDateString("ru-RU")}</div>
              <p>{SUBSCRIPTION_TYPE_NAME[order.orderType]}</p>
              <p>Способ оплаты: {order.paymentMethod}</p>
              <div>{Number(order.amount)} ₽</div>
            </div>
          ))
        )}
      </div>
    </DocumentPage>
  );
}

export default HistoryPage;
